import path from "path";
import { isPathInsideDirectory } from "../../utils/routeFileWatch";
function createRouteModuleHmrPlugin(routerRoot) {
  return {
    name: "route-module-hmr-fix",
    // the router swallows a failed route import and renders an empty component
    // in its place (see useViteRoutes resolve). that is right for production and
    // wrong for dev, where it meant a broken import anywhere in a route's module
    // graph produced a blank app, no terminal output, and one console line — with
    // every provider inside that route silently never mounting. the client paints
    // its own overlay (devtools/dev.mjs) and reports here so the failure also
    // reaches the terminal, where the person running the dev server is looking.
    configureServer(server) {
      server.hot.on("one:route-error", function(data) {
        var id = (data === null || data === void 0 ? void 0 : data.id) || "unknown route";
        var message = (data === null || data === void 0 ? void 0 : data.message) || "unknown error";
        server.config.logger.error(`[one] route failed to load: ${id}
  ${message}
  the router rendered an empty component in its place, so nothing inside this route mounted.`, {
          timestamp: true
        });
      });
    },
    hotUpdate(param) {
      var { server, modules, file } = param;
      var _this_environment;
      var absoluteRouterRoot = path.resolve(server.config.root, routerRoot);
      var fileRelativePath = path.relative(server.config.root, file);
      if (((_this_environment = this.environment) === null || _this_environment === void 0 ? void 0 : _this_environment.name) === "ssr" && isPathInsideDirectory(file, absoluteRouterRoot)) {
        return [];
      }
      var hasRouteUpdate = false;
      var result = modules.map(function(module) {
        if (!module.id) return module;
        var moduleFile = module.id.split("?")[0];
        if (isPathInsideDirectory(moduleFile, absoluteRouterRoot)) {
          var relativeRoutePath = path.relative(absoluteRouterRoot, moduleFile);
          module.acceptedHmrExports = /* @__PURE__ */ new Set();
          if (/^(?:\([^)]+\)[\\/])?_layout\.[jt]sx?$/.test(relativeRoutePath)) {
            hasRouteUpdate = true;
          }
        }
        return module;
      });
      if (hasRouteUpdate) {
        server.hot.send({
          type: "custom",
          event: "one:route-update",
          data: {
            file: fileRelativePath
          }
        });
      }
      return result;
    }
  };
}
export {
  createRouteModuleHmrPlugin
};
//# sourceMappingURL=routeModuleHmrPlugin.js.map
